// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page wrapper ── */
.mc-page {
  display: flex;
  justify-content: center;
  padding: 24px 16px 64px;
  min-height: 100%;
}

.mc-container {
  width: 100%;
  max-width: 780px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Header ── */
.mc-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.mc-header-icon-wrap {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 16px;
  background: rgba(59, 179, 174, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.mc-header-icon {
  color: #48D1CC !important;
  font-size: 28px !important;
}

.mc-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
}

.mc-subtitle {
  margin: 4px 0 0;
  font-size: 14px;
  color: #9aa3ad;
}

/* ── List ── */
.mc-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Card ── */
.mc-card {
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid #484848;
  padding: 20px;
  display: flex;
  gap: 18px;
  align-items: flex-start;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.18s ease;
}

.mc-card:hover {
  border-color: #3BB3AE;
  transform: translateY(-2px);
}

.mc-card-expired {
  opacity: 0.72;
  border-color: rgba(255, 167, 38, 0.15);
}

/* ── Badge icon ── */
.mc-badge-icon {
  width: 64px;
  height: 64px;
  min-width: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ── Card body ── */
.mc-card-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.mc-card-top-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.mc-cert-name {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #e6eaef;
  line-height: 1.3;
}

.mc-cert-number {
  margin: 0;
  font-size: 12px;
  color: #64707d;
  font-family: monospace;
}

.mc-expired-badge {
  font-size: 11px;
  font-weight: 700;
  background: rgba(255, 167, 38, 0.12);
  color: #ffa726;
  border-radius: 20px;
  padding: 3px 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

.mc-active-badge {
  font-size: 11px;
  font-weight: 700;
  background: rgba(75, 227, 207, 0.12);
  color: #4be3cf;
  border-radius: 20px;
  padding: 3px 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── Meta chips ── */
.mc-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mc-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #071414;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 12px;
  color: #9aa3ad;
}

.mc-meta-score {
  color: #48D1CC;
  font-weight: 700;
  background: rgba(59, 179, 174, 0.1);
}

.mc-meta-expired {
  color: #ffa726;
}

/* ── Card actions ── */
.mc-card-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding-top: 4px;
}

.mc-btn-view {
  padding: 8px 18px;
  border-radius: 10px;
  border: 1px solid #484848;
  background: transparent;
  color: #c5cdd6;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}
.mc-btn-view:hover { border-color: #48D1CC; color: #48D1CC; }

.mc-btn-download {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 10px;
  border: none;
  background: rgba(59, 179, 174, 0.15);
  color: #48D1CC;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.mc-btn-download:not(:disabled):hover { opacity: 0.82; transform: translateY(-1px); }
.mc-btn-download:disabled { opacity: 0.45; cursor: not-allowed; }

/* ── Empty state ── */
.mc-empty {
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid #484848;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}

.mc-empty-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #e6eaef;
}

.mc-empty-sub {
  margin: 0;
  font-size: 14px;
  color: #9aa3ad;
  max-width: 320px;
  line-height: 1.6;
}

.mc-btn-browse {
  margin-top: 12px;
  padding: 10px 28px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.mc-btn-browse:hover { opacity: 0.88; transform: translateY(-1px); }

/* ── Skeletons ── */
.mc-card-skeleton {
  cursor: default;
  pointer-events: none;
}

.mc-skel-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mc-skeleton {
  border-radius: 8px;
  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);
  background-size: 200% 100%;
  animation: mcSkeleton 1.4s ease infinite;
}

.mc-skel-badge  { width: 64px; height: 64px; border-radius: 16px; flex-shrink: 0; }
.mc-skel-title  { width: 55%; height: 18px; }
.mc-skel-meta   { width: 80%; height: 13px; }
.mc-skel-btn    { width: 40%; height: 32px; border-radius: 10px; }

@keyframes mcSkeleton {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .mc-card { flex-direction: column; }
  .mc-badge-icon { width: 52px; height: 52px; }
  .mc-title { font-size: 20px; }
}

/* ── Stats Section ── */
.mc-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 8px;
}

.mc-stat-card {
  background: rgba(14, 27, 27, 0.45);
  backdrop-filter: blur(12px);
  border: 1px solid #484848;
  border-radius: 18px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Make actionable cards look clickable */
.mc-stat-card-progress,
.mc-stat-card-available {
  cursor: pointer;
}

.mc-stat-card:hover {
  transform: translateY(-4px);
}

.mc-stat-card-earned:hover {
  border-color: #3BB3AE;
  box-shadow: 0 6px 20px rgba(59, 179, 174, 0.15);
}

.mc-stat-card-progress:hover {
  border-color: #FF9F43;
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.15);
}

.mc-stat-card-available:hover {
  border-color: #4B6FE6;
  box-shadow: 0 6px 20px rgba(75, 111, 230, 0.15);
}

.mc-stat-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.mc-stat-card:hover .mc-stat-icon-wrap {
  transform: scale(1.1);
}

.mc-stat-icon {
  font-size: 24px !important;
}

/* Icon Wrap Themes */
.theme-emerald {
  background: rgba(59, 179, 174, 0.15);
  color: #48D1CC;
  border: 1px solid rgba(59, 179, 174, 0.25);
}

.theme-amber {
  background: rgba(255, 159, 67, 0.15);
  color: #FF9F43;
  border: 1px solid rgba(255, 159, 67, 0.25);
}

.theme-indigo {
  background: rgba(75, 111, 230, 0.15);
  color: #7491F6;
  border: 1px solid rgba(75, 111, 230, 0.25);
}

.mc-stat-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.mc-stat-value {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.1;
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.mc-stat-value-sub {
  font-size: 13px;
  color: #64707d;
  font-weight: 500;
}

.mc-stat-label {
  margin: 0;
  font-size: 13px;
  color: #9aa3ad;
  font-weight: 500;
}

/* Skeletons for Stats */
.mc-stat-card-skeleton {
  cursor: default;
  pointer-events: none;
}

.mc-stat-skel-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  flex-shrink: 0;
}

.mc-stat-skel-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mc-stat-skel-value {
  width: 40%;
  height: 20px;
}

.mc-stat-skel-label {
  width: 70%;
  height: 12px;
}

/* Responsive adjustments */
@media (max-width: 680px) {
  .mc-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .mc-stats-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .mc-stat-card {
    padding: 12px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/MyCertificates/MyCertificates.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;AACA,qBAAqB,qBAAqB,EAAE,cAAc,EAAE;;AAE5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;AACA,wCAAwC,aAAa,EAAE,2BAA2B,EAAE;AACpF,4BAA4B,aAAa,EAAE,mBAAmB,EAAE;;AAEhE,sBAAsB;AACtB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;AACA,uBAAuB,aAAa,EAAE,2BAA2B,EAAE;;AAEnE,oBAAoB;AACpB;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAClF,kBAAkB,UAAU,EAAE,YAAY,EAAE;AAC5C,kBAAkB,UAAU,EAAE,YAAY,EAAE;AAC5C,kBAAkB,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAEjE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE,WAAW,sBAAsB,EAAE;EACnC,iBAAiB,WAAW,EAAE,YAAY,EAAE;EAC5C,YAAY,eAAe,EAAE;AAC/B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kDAAkD;AACpD;;AAEA,yCAAyC;AACzC;;EAEE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Page wrapper ── */\n.mc-page {\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px 64px;\n  min-height: 100%;\n}\n\n.mc-container {\n  width: 100%;\n  max-width: 780px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Header ── */\n.mc-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.mc-header-icon-wrap {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n  border-radius: 16px;\n  background: rgba(59, 179, 174, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mc-header-icon {\n  color: #48D1CC !important;\n  font-size: 28px !important;\n}\n\n.mc-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.mc-subtitle {\n  margin: 4px 0 0;\n  font-size: 14px;\n  color: #9aa3ad;\n}\n\n/* ── List ── */\n.mc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* ── Card ── */\n.mc-card {\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid #484848;\n  padding: 20px;\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n  cursor: pointer;\n  transition: border-color 0.2s ease, transform 0.18s ease;\n}\n\n.mc-card:hover {\n  border-color: #3BB3AE;\n  transform: translateY(-2px);\n}\n\n.mc-card-expired {\n  opacity: 0.72;\n  border-color: rgba(255, 167, 38, 0.15);\n}\n\n/* ── Badge icon ── */\n.mc-badge-icon {\n  width: 64px;\n  height: 64px;\n  min-width: 64px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* ── Card body ── */\n.mc-card-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.mc-card-top-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.mc-cert-name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #e6eaef;\n  line-height: 1.3;\n}\n\n.mc-cert-number {\n  margin: 0;\n  font-size: 12px;\n  color: #64707d;\n  font-family: monospace;\n}\n\n.mc-expired-badge {\n  font-size: 11px;\n  font-weight: 700;\n  background: rgba(255, 167, 38, 0.12);\n  color: #ffa726;\n  border-radius: 20px;\n  padding: 3px 10px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.mc-active-badge {\n  font-size: 11px;\n  font-weight: 700;\n  background: rgba(75, 227, 207, 0.12);\n  color: #4be3cf;\n  border-radius: 20px;\n  padding: 3px 10px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* ── Meta chips ── */\n.mc-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.mc-meta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #071414;\n  border-radius: 20px;\n  padding: 4px 10px;\n  font-size: 12px;\n  color: #9aa3ad;\n}\n\n.mc-meta-score {\n  color: #48D1CC;\n  font-weight: 700;\n  background: rgba(59, 179, 174, 0.1);\n}\n\n.mc-meta-expired {\n  color: #ffa726;\n}\n\n/* ── Card actions ── */\n.mc-card-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding-top: 4px;\n}\n\n.mc-btn-view {\n  padding: 8px 18px;\n  border-radius: 10px;\n  border: 1px solid #484848;\n  background: transparent;\n  color: #c5cdd6;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n}\n.mc-btn-view:hover { border-color: #48D1CC; color: #48D1CC; }\n\n.mc-btn-download {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 18px;\n  border-radius: 10px;\n  border: none;\n  background: rgba(59, 179, 174, 0.15);\n  color: #48D1CC;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n.mc-btn-download:not(:disabled):hover { opacity: 0.82; transform: translateY(-1px); }\n.mc-btn-download:disabled { opacity: 0.45; cursor: not-allowed; }\n\n/* ── Empty state ── */\n.mc-empty {\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid #484848;\n  padding: 56px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n}\n\n.mc-empty-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #e6eaef;\n}\n\n.mc-empty-sub {\n  margin: 0;\n  font-size: 14px;\n  color: #9aa3ad;\n  max-width: 320px;\n  line-height: 1.6;\n}\n\n.mc-btn-browse {\n  margin-top: 12px;\n  padding: 10px 28px;\n  border-radius: 12px;\n  border: none;\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n.mc-btn-browse:hover { opacity: 0.88; transform: translateY(-1px); }\n\n/* ── Skeletons ── */\n.mc-card-skeleton {\n  cursor: default;\n  pointer-events: none;\n}\n\n.mc-skel-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mc-skeleton {\n  border-radius: 8px;\n  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);\n  background-size: 200% 100%;\n  animation: mcSkeleton 1.4s ease infinite;\n}\n\n.mc-skel-badge  { width: 64px; height: 64px; border-radius: 16px; flex-shrink: 0; }\n.mc-skel-title  { width: 55%; height: 18px; }\n.mc-skel-meta   { width: 80%; height: 13px; }\n.mc-skel-btn    { width: 40%; height: 32px; border-radius: 10px; }\n\n@keyframes mcSkeleton {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .mc-card { flex-direction: column; }\n  .mc-badge-icon { width: 52px; height: 52px; }\n  .mc-title { font-size: 20px; }\n}\n\n/* ── Stats Section ── */\n.mc-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.mc-stat-card {\n  background: rgba(14, 27, 27, 0.45);\n  backdrop-filter: blur(12px);\n  border: 1px solid #484848;\n  border-radius: 18px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Make actionable cards look clickable */\n.mc-stat-card-progress,\n.mc-stat-card-available {\n  cursor: pointer;\n}\n\n.mc-stat-card:hover {\n  transform: translateY(-4px);\n}\n\n.mc-stat-card-earned:hover {\n  border-color: #3BB3AE;\n  box-shadow: 0 6px 20px rgba(59, 179, 174, 0.15);\n}\n\n.mc-stat-card-progress:hover {\n  border-color: #FF9F43;\n  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.15);\n}\n\n.mc-stat-card-available:hover {\n  border-color: #4B6FE6;\n  box-shadow: 0 6px 20px rgba(75, 111, 230, 0.15);\n}\n\n.mc-stat-icon-wrap {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.mc-stat-card:hover .mc-stat-icon-wrap {\n  transform: scale(1.1);\n}\n\n.mc-stat-icon {\n  font-size: 24px !important;\n}\n\n/* Icon Wrap Themes */\n.theme-emerald {\n  background: rgba(59, 179, 174, 0.15);\n  color: #48D1CC;\n  border: 1px solid rgba(59, 179, 174, 0.25);\n}\n\n.theme-amber {\n  background: rgba(255, 159, 67, 0.15);\n  color: #FF9F43;\n  border: 1px solid rgba(255, 159, 67, 0.25);\n}\n\n.theme-indigo {\n  background: rgba(75, 111, 230, 0.15);\n  color: #7491F6;\n  border: 1px solid rgba(75, 111, 230, 0.25);\n}\n\n.mc-stat-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.mc-stat-value {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.1;\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.mc-stat-value-sub {\n  font-size: 13px;\n  color: #64707d;\n  font-weight: 500;\n}\n\n.mc-stat-label {\n  margin: 0;\n  font-size: 13px;\n  color: #9aa3ad;\n  font-weight: 500;\n}\n\n/* Skeletons for Stats */\n.mc-stat-card-skeleton {\n  cursor: default;\n  pointer-events: none;\n}\n\n.mc-stat-skel-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  flex-shrink: 0;\n}\n\n.mc-stat-skel-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mc-stat-skel-value {\n  width: 40%;\n  height: 20px;\n}\n\n.mc-stat-skel-label {\n  width: 70%;\n  height: 12px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 680px) {\n  .mc-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .mc-stats-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  .mc-stat-card {\n    padding: 12px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
